
import { createContext, useState, useEffect } from "react"
import axios from 'axios'
import { ToastContainer, toast,Slide, Zoom, Flip, Bounce,cssTransition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";



export const UserContext = createContext();

export const UserProvider = ({children}) => {

const [userInfo, setUserinfo] = useState({auth:false});
const [empid, setEmpid] = useState('');
const [reset, setReset] = useState(false);
const [spin, setSpin] = useState(false)
const [userName, setUserName] = useState('')
const [employees, setEmployees] = useState([])
const [customers, setCustomers] = useState([])
const [salesreps, setSalesreps] = useState([])
const [csrreps, setCsrreps] = useState([])
const [auth, setAuth] = useState(null)
const nav = useNavigate()

const [loginusers, setLoginusers] = useState([{user:"joanne@joijewerly.com",pass:"Mybae"}])

useEffect(() => {

//   const getuser = async() => {
// let h = {id:sessionStorage.getItem('user')}
// console.log(h)
// const resp = await axios.post('http://localhost:5003/users/getuser',h)
// console.log(resp)
// if(resp.data.status === 200){
//  setUserinfo(resp.data?.message[0])
// }
//   }

//   const getcustomers = async() => {
//        const res = await axios.get('https://highgroundapi.herokuapp.com/customers/all')
//        setCustomers(res.data)
//   }

//    const getSalesRep = async() => {
//        const res = await axios.get('https://highgroundapi.herokuapp.com/employee/sales')
//        console.log(res.data)
//        setSalesreps(res.data)
//   }
//     const getCsrRep = async() => {
//        const res = await axios.get('https://highgroundapi.herokuapp.com/employee/csr')
//        console.log(res.data)
//        setCsrreps(res.data)
//   }
//   getCsrRep()
//   getSalesRep()
// getuser()
// getcustomers()
},[])

useEffect(() => {
if(!auth){
nav('/',{ replace: true })
}
},[])


const logout= () => {
  sessionStorage.removeItem('user')
  nav('/',{replace: true})
}

const login= async(email,pass) => {
console.log(email)
let user = loginusers.filter(filt => filt.user === email)
console.log(user)
console.log(pass)
if(!email){
return toast.error('Email is required')
}
if(!pass){
return toast.error('Password is required')
}
// if(user.length === 0){
// return toast.error('Envalid Email')
// }

if(pass !== 'Mybae'){
return toast.error('Invalid Credentials')
}

setAuth(true)
  nav('/dashboard')
}



const value={
  logout,
  setUserinfo,
  userInfo,
  login,
  customers,
  salesreps,
  csrreps
}


  return (
    <UserContext.Provider value={value}>
         <ToastContainer position="top-center" theme="dark"  autoClose="2000" hideProgressBar={true} transition={Flip} />
        {children}
    </UserContext.Provider>
  )
}

export default UserContext 